// Module
var code = "<div class=\"field is-horizontal\"> <div class=\"field-label is-normal\"> <label class=\"label\">:outputName</label> </div> <div class=\"field-body\"> <div class=\"field\"> <p class=\"control\"> <input class=\"input\" type=\"text\" value=\":inputValue\" readonly=\"readonly\" disabled=\"disabled\"> </p> </div> </div> </div> ";
// Exports
export default code;